<template>
    <div>
        <b-card title="" border-variant="primary">
            <div class="d-flex align-items-center justify-content-between mb-1">
                <h5 class="mb-0">OCAs</h5>
              <b-button
                        variant="outline-success"
                        class="btn btn-outline-success"
                        :disabled="hasMatchingDocument"
                        @click="addRow"
              >
                <feather-icon
                    icon="PlusIcon"
                    size="16"
                    variant="success"
                    class="cursor-pointer "
                />
              </b-button>
            </div>
            <form-base-document
                :documents-state-data="documents_oca"
                :documents-columns="columns"
                :documents-route="documents_by_route_oca"
                :context="'document-oca'"
                :create-permission="can('create_vhe_master_ocas')"
                :delete-permission="can('delete_vhe_master_ocas')"
            />

        </b-card>

    </div>
</template>

<script>
import {BCard, BButton} from 'bootstrap-vue'
import {mapState} from "vuex"
import formBaseDocument from "@/views/vhe/masters_installations/form/tabOca/components/base/formBaseDocument"
import {mapFields} from "vuex-map-fields"
import {ocasPeriodicity, ocasType} from "@/constants/constants"

export default {
    name: "FormOca",
    components: {
        BCard,
        BButton,
        formBaseDocument,
    },
    data() {
        return {
            columns: [
                {key: 'options', label: 'Acciones', sortable: false},
                {key: 'color', label: '', sortable: false},
                {key: 'expected_date', label: 'Fecha Prevista', sortable: false},
                {key: 'effective_date', label: 'Fecha Realización', sortable: false},
                {key: 'observations', label: 'Observaciones', sortable: false},
                {key: 'passed', label: 'Pasada', sortable: false},
                {key: 'defects', label: 'Defectos', sortable: false},
                {key: 'acting', label: 'Actuante', sortable: false},
                {key: 'periodicity', label: 'Periodicidad', sortable: false},
                {key: 'performance', label: 'Actuación', sortable: false},
                {key: 'periodicity_observations', label: 'Observaciones a la actuación', sortable: false},
                // {key: 'inspection.type', label: 'Tipo', sortable: false},
            ],


        }
    },
    computed: {
        ...mapState('masterInstallationVhe', ['master_installation']),
        ...mapState('masterInstallationDocumentsVhe', []),
        ...mapFields({
            documents_oca: 'masterInstallationDocumentsVhe.documents_oca',
            documents_by_route_oca: 'masterInstallationDocumentsVhe.documents_by_route_oca',

        }),
        hasMatchingDocument() {
          return this.documents_oca.some(doc => doc.empty_row === true)
        }
    },
    mounted() {
        this.context = 'document-oca'
    },
    methods: {
        can(permission) {
            return this.$store.getters.can(permission)
        },
        addRow() {
            const newRow = {
                empty_row: true,
                start_date: null,
                end_date: null,
                provider_id: null,
                order_number: null,
                request_date: null,
                order_maintenance_type_id: null,
                order_maintenance_sub_type_id: null,
                route: this.master_installation.installation_code + "/OCA",
                master_installation_id: this.master_installation.id,
                observations: null,
                options: null,
            }

            this.documents_oca.unshift(newRow)
            this.documents_oca.editedRow = newRow
        },
    }

}
</script>